import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Cdowhile(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
       <Sides/>

       <Helmet>
 
 <title>C do-while Statement tutorial For Beginners</title>
 <meta name="description" content="C do-while tutorial for beginners.In do while C loop will always execute at least once,CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,learn code in free,c programming tutorial for beginners,learn code in free online,c do while,do while in c,c do while loop,do while loop in c,c programming do while loop,do while c programming,do while in c programming,c do while loop example,c language do while loop,do while in c example,c do while continue,c do while loop syntax" />
 <link rel="canonical" href="https://www.codeexampler.com/c-do-while" />
 </Helmet>

 <div className='lg:pl-56'>

    <h1 className="m-4 mh1">Do-while Statement in C</h1>
    <div className="first">
        <a href="/c-while">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/c-for-loop">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <p className="mt-4 para">In Do-While loop will consistently execute at least once
</p>


<h2 className="headings">Do-while loop C Syntax</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
              <span className="qwerty-6">do </span>
            <span className="qwerty-4">&#123;</span>
              {"\n"} 
              <span className="qwerty-3">    statement</span>
              <span className="qwerty-4">;</span>
              {"\n"} 
            <span className="qwerty-4">   &#125;</span>
              <span className="qwerty-6"> while</span>
              <span className="qwerty-4"> (</span>
              <span className="qwerty-10">condition</span>
              <span className="qwerty-4">);</span>
              {"\n"} 
              {"\n"} 
          </code>
        </pre>
      </div> 



<h2 className="headings">Q-Write a program do while C loop example no from 1 to 10?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
          {"\n"}
              <span className="qwerty-7">#include </span>
                <span className="qwerty-4">&#60;</span>
                <span className="qwerty-10">stdio.h</span>
                <span className="qwerty-4">&#62; </span>
            {"\n"}
            <span className="qwerty-3">int </span>
                <span className="qwerty-2">main</span>
                <span className="qwerty-4"> ()</span>            
            {"\n"}
            <span className="qwerty-4" >&#123; </span>            
            {"\n"}     
            <span className="qwerty-3"> int</span>
                <span className="qwerty-5"> a</span>
                -<span className="qwerty-4">=</span>
                <span className="qwerty-1">1</span>
                <span className="qwerty-4">;</span>                
              {"\n"}      
            <span className="qwerty-6"> do </span>
            {"\n"}
            <span className="qwerty-4"> &#123;</span>
              {"\n"}              
              <span className="qwerty-8">  printf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-3">%d</span>
                <span className="qwerty-10"> \n</span>
                <span className="qwerty-4">",</span>
                <span className="qwerty-5"> a</span>
                <span className="qwerty-4">);</span>
            {"\n"}
            <span className="qwerty-5">  a</span>
                    <span className="qwerty">++</span>
                    <span className="qwerty-4">;</span>                   
              {"\n"} 
            <span className="qwerty-4"> &#125;</span>
              <span className="qwerty-6"> while</span>
              <span className="qwerty-4"> (</span>
              <span className="qwerty-5">a</span>
              <span className="qwerty">&#60;=</span>
              <span className="qwerty-1">10</span>
              <span className="qwerty-4">);</span>
              {"\n"}
                <span className="qwerty-7"> return</span>
                <span className="qwerty-3"> 0</span>
                <span className="qwerty-4">; </span>
              {"\n"}
              <span className="qwerty-4">&#125;</span>
              {"\n"}
              {"\n"} 
              </code>
        </pre>
      </div>   
      <h4 className='headings'>Output :</h4>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}}>
          <pre style={{maxHeight:"100vh"}}>
                <code >                  
                {"\n"}      
                  <span className="qwerty-1">1</span>                   
                  {"\n"}         
                  <span className="qwerty-10">2</span>                   
                  {"\n"}         
                  <span className="qwerty-1">3</span>                   
                  {"\n"}         
                  <span className="qwerty-10">4</span>                   
                  {"\n"}         
                  <span className="qwerty-1">5</span>                   
                  {"\n"}         
                  <span className="qwerty-10">6</span>                   
                  {"\n"}         
                  <span className="qwerty-1">7</span>                   
                  {"\n"}         
                  <span className="qwerty-10">8</span>                   
                  {"\n"}         
                  <span className="qwerty-1">9</span>                   
                  {"\n"}         
                  <span className="qwerty-10">10</span>                   
                  {"\n"}         
                  {"\n"}         
                </code>
                </pre>
                </div> 



<h2 className="headings">Q-Write a program decrement in C do-while loop no from 10 to 1?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-7">#include </span>
                <span className="qwerty-4">&#60;</span>
                <span className="qwerty-10">stdio.h</span>
                <span className="qwerty-4">&#62; </span>
                        {"\n"}             
                <span className="qwerty-3">int </span>
                <span className="qwerty-2">main</span>
                <span className="qwerty-4"> ()</span>            
            {"\n"}            
            <span className="qwerty-4" >&#123; </span>            
            {"\n"}
                <span className="qwerty-3"> int</span>
                <span className="qwerty-5"> a</span>
                -<span className="qwerty-4">=</span>
                <span className="qwerty-1">10</span>
                <span className="qwerty-4">;</span>                
              {"\n"}
              <span className="qwerty-6"> do </span>
              {"\n"} 
            <span className="qwerty-4"> &#123;</span>
              {"\n"} 
              <span className="qwerty-8">  printf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-3">%d</span>
                <span className="qwerty-10"> \n</span>
                <span className="qwerty-4">",</span>
                <span className="qwerty-5"> a</span>
                <span className="qwerty-4">);</span>
              {"\n"} 
              <span className="qwerty-5">  a</span>
                    <span className="qwerty">--</span>
                    <span className="qwerty-4">;</span>                   
                              {"\n"}
              <span className="qwerty-4"> &#125;</span>
              <span className="qwerty-6"> while</span>
              <span className="qwerty-4"> (</span>
              <span className="qwerty-5">a</span>
              <span className="qwerty">&#62;=</span>
              <span className="qwerty-1">1</span>
              <span className="qwerty-4">);</span>
            {"\n"}
              <span className="qwerty-7"> return</span>
                <span className="qwerty-3"> 0</span>
                <span className="qwerty-4">; </span>
                {"\n"}
              <span className="qwerty-4">&#125;</span>
              {"\n"} 
              {"\n"} 
          </code>
        </pre>
      </div>
      <h4 className='headings'>Output :</h4>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}}>
          <pre style={{maxHeight:"100vh"}}>
                <code >                  
                {"\n"}      
                  <span className="qwerty-1">10</span>                   
                  {"\n"}          
                  <span className="qwerty-10">9</span>                   
                  {"\n"}         
                  <span className="qwerty-1">8</span>                   
                  {"\n"}          
                  <span className="qwerty-10">7</span>                   
                  {"\n"}          
                  <span className="qwerty-1">6</span>                   
                  {"\n"}          
                  <span className="qwerty-10">5</span>                   
                  {"\n"}          
                  <span className="qwerty-1">4</span>                   
                  {"\n"}          
                  <span className="qwerty-10">3</span>                   
                  {"\n"}          
                  <span className="qwerty-1">2</span>                   
                  {"\n"}          
                  <span className="qwerty-10">1</span>                   
                  {"\n"}       
                  {"\n"}       
                </code>
                </pre>
                </div>


<h1 className="mt-5">  </h1>
<div className="back">
        <a href="/c-while">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/c-for-loop">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Cdowhile;